module.exports = __webpack_public_path__ + "static/media/credit_profile.48765e5d.png";